<template>
  <div>
    <v-tabs v-model="tabTitle">
      <v-tab href="#tab-1">{{ $t('engineer_tab_one') }}</v-tab>
      <v-tab href="#tab-2">{{ $t('engineer_tab_two') }}</v-tab>
      <v-tab href="#tab-3">{{ $t('engineer_tab_three') }}</v-tab>
      <v-tab-item value="tab-1">
        <engineer-work-not-work
          ref="notWork"
          :maintenanceEngineers="maintenanceEngineers"
          :allSpecialNeedList="allSpecialNeedList"
          :headerProps="headerProps"
          :getUserAccountId="getUserAccountId"
          :tabTitle="tabTitle"
        />
      </v-tab-item>
      <v-tab-item value="tab-2">
        <engineer-work-not-done
          ref="notDoneWork"
          :maintenanceEngineers="maintenanceEngineers"
          :allSpecialNeedList="allSpecialNeedList"
          :headerProps="headerProps"
          :getUserAccountId="getUserAccountId"
          :tabTitle="tabTitle"
        />
      </v-tab-item>
      <v-tab-item value="tab-3">
        <engineer-work-done
          ref="doneWork"
          :maintenanceEngineers="maintenanceEngineers"
          :allSpecialNeedList="allSpecialNeedList"
          :headerProps="headerProps"
          :tabTitle="tabTitle"
        />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { HttpUser, HttpSpecialNeed } from '@/js/http-Manager'
import EngineerWorkNotWork from '@/components/EngineerWork/EngineerWorkNotWork.vue'
import EngineerWorkDone from '@/components/EngineerWork/EngineerWorkDone.vue'
import EngineerWorkNotDone from '@/components/EngineerWork/EngineerWorkNotDone.vue'
export default {
  components: {
    EngineerWorkNotWork,
    EngineerWorkDone,
    EngineerWorkNotDone
  },
  name: 'EngineerWork',

  data: () => ({
    maintenanceEngineers: [],
    allSpecialNeedList: [],
    tabTitle: 'tab-1'
  }),

  computed: {
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    ...mapGetters('login', {
      getUserAccountId: 'getUserAccountId'
    })
  },
  async mounted () {
    await this.getEngineerUser()
    await this.getSpecialNeedList()
  },

  methods: {
    async getSpecialNeedList () {
      let response = await HttpSpecialNeed.GetSpecialNeed()
      this.allSpecialNeedList = response.status === 200 ? response.data.Data : []
    },

    async getEngineerUser () {
      let response = await HttpUser.GetEngineerUser()
      this.maintenanceEngineers = response.status === 200 ? response.data.Data : []
    }
  }
}
</script>
